import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  id: "barcode",
  class: "hidden",
  alt: "barcode"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("img", {
      id: "logo",
      src: require(`@/app/ui/assets/images/logo-${_ctx.roleAccount}.png`),
      class: "hidden",
      alt: "logo"
    }, null, 8, ["src"]),
    _createVNode("img", {
      id: "company-logo",
      src: require('@/app/ui/assets/images/logo-lion-parcel.png'),
      class: "hidden",
      alt: "logo"
    }, null, 8, ["src"]),
    _hoisted_1
  ], 64))
}